export const IDiscountListItem = {
  id: 1,
  name: 'Holiday Sale',
  discount_type: 1,
  terms: 'Applies to selected items only.',
  included_items: [101, 102, 103],
  exclude_items: [150, 151],
  is_active: true,
  rate: '10.500',
  rate_type: 0,
  variable_rate: false,
  auto_apply: true,
  has_max_discount_value: true,
  max_discount_value: '50.000',
  has_min_spent_value: false,
  min_spent_value: '0.000',
  availability_type: 1,
  availability: {},
  discount_type2_type: 0,
  purchase_qty: 3,
  discount_qty: 1,
  with_percent: '20.00',
  id2: '',
  id2_type: 0,
  id2_undated_at: '2023-10-20T20:22:57.713Z',
  last_user_id: 32,
  created_at: '2023-10-20T20:22:57.713Z',
  updated_at: '2023-10-20T20:22:57.713Z',
  is_archive: false,
  archived_at: null,
}
